import ApiService from '@/services/api.service'

const AttendancesService = {

    delete(id){
      return ApiService.delete(`/Attendances/${id}`)
    },

    update(data){
      return ApiService.put(`/Attendances/UpdateChargeSheet/`,data)
    },

    insert(data){
      return ApiService.post(`/Attendances/InsertChargeSheet/`,data)
    },

}

  export default AttendancesService;
